import slugify from 'slugify';

export const slugifyTestTypeFamilyName = (testTypeFamilyName: string): string =>
  slugify(testTypeFamilyName.replace(/[^a-zA-Z0-9 ]/g, '')).toLowerCase();
